"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_object_1 = __importDefault(require("./image-object"));
class HabitJourney extends base_1.default {
    constructor(data = {
        id: undefined,
        title: undefined,
        subtitle: undefined,
        icon: undefined,
        primary_color: undefined,
        secondary_color: undefined,
        order: undefined,
        habits: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.title = (0, defaults_1.defaultString)(data.title);
        this.subtitle = (0, defaults_1.defaultString)(data.subtitle);
        this.icon = new image_object_1.default((0, defaults_1.defaultObject)(data.icon));
        this.primary_color = (0, defaults_1.defaultString)(data.primary_color);
        this.secondary_color = (0, defaults_1.defaultString)(data.secondary_color);
        this.order = (0, defaults_1.defaultNumber)(data.order);
        this.habits = (0, defaults_1.defaultArray)(data.habits);
    }
    get getHabits() {
        return this.habits.toString().split(',');
    }
    get primaryColor() {
        return this.primary_color;
    }
    get secondaryColor() {
        return this.secondary_color;
    }
}
exports.default = HabitJourney;
